import Vue from 'vue';
import store from './../../store';
import Logout from './logout';

// When the request succeeds
const success = (response) => {
  store.dispatch('auth/check', response); // .then(() => { });
};


export default () => {
  if (localStorage.getItem('token') !== null) {
    Vue.prototype.$http.get('/auth').then((response) => {
      success(response.data);
      /*
      if (Vue.router.currentRoute.meta.roles) {
        const userRoles = store.getters['auth/getCurrentUser'].roles;
        const hasPermission = userRoles.find(
          (role) => Vue.router.currentRoute.meta.roles.includes(role.uniqueKey),
        );
        if (!hasPermission) {
          Logout();
        }
      }
      */
    });
  }
};
